export enum LeaveCriteria {
  FULL_TIME = 1
}
